import { Route, Routes } from 'react-router';

import PrivateRoute from 'app/components/Util/PrivateRoute';

import { WatchlistList } from './WatchlistList';

export const Watchlist = ({ currentUser }) => {
  return (
    <Routes>
      <Route
        index
        element={
          <PrivateRoute
            notAnonymous // because of this, everyone can access it currently
            user={currentUser}
          >
            <WatchlistList />
          </PrivateRoute>
        }
      />
    </Routes>
  );
};
